import { downloadCsv } from './csv/downloadCsv'
import { CSV_DELIMITER, serializeCsvRows } from './csv/serializeCsvRows'
import { formatDateKey } from './dateUtils'
import { MY_TEAM_CONSTANTS } from '../const'
import { MyTeamEmployeeData } from '../types'

const { HOURS_PER_DAY } = MY_TEAM_CONSTANTS

interface MyTeamSummaryMetrics {
  totalTrackedDays: number
  totalTrackedHours: number
  totalBillableDays: number
  totalBillableHours: number
  totalNonBillableDays: number
  totalNonBillableHours: number
  avgUtilization: number
}

const buildHeaderRow = (daysInMonth: Date[]): string[] => [
  'Team Member',
  'Tracked',
  'Billable',
  'Non-Billable',
  'Not Tracked',
  'Utilization',
  ...daysInMonth.map((_, index) => `Day ${index + 1}`),
]

const toEmployeeRow = (
  employee: MyTeamEmployeeData,
  daysInMonth: Date[],
): string[] => [
  employee.userName,
  `${Math.round(employee.totalHours / HOURS_PER_DAY)}d / ${Math.round(employee.totalHours)}h`,
  `${Math.round(employee.billableHours / HOURS_PER_DAY)}d / ${Math.round(employee.billableHours)}h`,
  `${Math.round(employee.nonBillableHours / HOURS_PER_DAY)}d / ${Math.round(employee.nonBillableHours)}h`,
  `${Math.round(employee.notTrackedHours / HOURS_PER_DAY)}d / ${Math.round(employee.notTrackedHours)}h`,
  `${employee.utilization}%`,
  ...daysInMonth.map((day) =>
    String(employee.dailyHours.get(formatDateKey(day)) || 0),
  ),
]

export const exportMyTeamToCSV = (
  employees: MyTeamEmployeeData[],
  daysInMonth: Date[],
  summaryMetrics: MyTeamSummaryMetrics,
  monthLabel: string,
): boolean => {
  try {
    if (employees.length === 0) {
      console.warn('No employee data to export')
      return false
    }

    const rows: string[][] = [
      [`My Team Report - ${monthLabel}`],
      [''],
      ['Summary Metrics'],
      [
        'Tracked',
        `${summaryMetrics.totalTrackedDays}d / ${summaryMetrics.totalTrackedHours}h`,
      ],
      [
        'Billable',
        `${summaryMetrics.totalBillableDays}d / ${summaryMetrics.totalBillableHours}h`,
      ],
      [
        'Non-Billable',
        `${summaryMetrics.totalNonBillableDays}d / ${summaryMetrics.totalNonBillableHours}h`,
      ],
      ['Utilization', `${summaryMetrics.avgUtilization}%`],
      [''],
      [''],
      buildHeaderRow(daysInMonth),
      ...employees.map((employee) => toEmployeeRow(employee, daysInMonth)),
    ]

    downloadCsv({
      content: serializeCsvRows(rows, CSV_DELIMITER.COMMA),
      fileName: `my-team-report-${monthLabel}.csv`,
      withBom: false,
    })

    return true
  } catch (error) {
    console.error('Failed to export CSV:', error)
    return false
  }
}
